const LAST_RELOAD_KEY = '__qc_stale_chunk_reload_at';
const RELOAD_COOLDOWN_MS = 60_000;

function readLastReload(): number {
  try {
    return Number(sessionStorage.getItem(LAST_RELOAD_KEY)) || 0;
  } catch {
    return 0;
  }
}

export function reloadOnStaleChunk(): void {
  const now = Date.now();
  if (now - readLastReload() < RELOAD_COOLDOWN_MS) return;
  try {
    sessionStorage.setItem(LAST_RELOAD_KEY, String(now));
  } catch {
    return;
  }
  window.location.reload();
}

export function registerStaleChunkReload(): void {
  window.addEventListener('vite:preloadError', reloadOnStaleChunk);
}
